import React, { useEffect, useState } from 'react';
import MeetingTalk from './MeetingTalk';
import YouTube from 'react-youtube';
import SwapPuzzle from '../puzzle/SwapPuzzle';
import BookCard from '../../components/BookCard';
import { scrollToElement } from '../../../lib/userFunctions';

export const StageTalk = ({meeting, storeMutate})=>{
    const [open, setOpen] = useState('');
    const [width, setWidth] = useState(320);

    useEffect(() => {
        scrollToElement();

        function handleResize() {
            const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            let newWidth = Math.max( Math.min(screenWidth, 500), 320 );
            if(newWidth<354)newWidth -= 30;
            setWidth(newWidth);
        }
    
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
          window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    const openClose = ()=>{
        setOpen(null);
    }
    return (
        <>
            <div className="toggleControls">
                { meeting.meeting.cover!==null && meeting.meeting.cover!=='' &&
                    <button className="btn btnPuzzle mgB10 _blue" onClick={()=>setOpen(open==='puzzle'?'':'puzzle')}><i className="fas fa-solid fa-puzzle-piece"></i> 퍼즐 다시하기</button>
                }
                { meeting.meeting.bookCard!==null && meeting.meeting.bookCard.length>0 &&
                    <button className="btn bookcardBtn mgB10 _blue" onClick={()=>setOpen(open==='card'?'':'card')}><i className="fas fa-solid fa-book-open"></i> 카드 다시보기</button>
                }
                {meeting.meeting.youtubeCode!==null && meeting.meeting.youtubeCode!=='' &&
                    <button className="btn btnYoutube mgB10 _blue" onClick={()=>setOpen(open==='youtube'?'':'youtube')}>독서영상</button>
                }
            </div>

            { open==='puzzle' &&
                <SwapPuzzle startDelay={5}  onPuzzleFinish={openClose} imageUrl={(null!==meeting.meeting.cover && meeting.meeting.cover.startsWith('http://') )?`${meeting.meeting.cover}`:meeting.meeting.cover}  />
            }
            
            { open==='card' &&
                <BookCard list={meeting.meeting.bookCard} onFinish={openClose} />
            }

            { open==='youtube' &&
                <div className="section info_area">
                        <div className="inner clear text-center">
                            <YouTube videoId={meeting.meeting.youtubeCode} opts={{
                                width: width, height: width * 0.5625,
                                playerVars: { autoplay: 0 }
                                }} />
                        </div>
                </div>
            }
            <MeetingTalk meeting={meeting.meeting} meetingUser={meeting.meetingUser} storeMutate={storeMutate} />
        </>
    )
};